import type { Category } from './valueObjects/category';
import type { CategoryId } from './valueObjects/categoryId';
import type { CategoryIndex } from './valueObjects/categoryIndex';
import type { CategoryItemCount } from './valueObjects/categoryItemCount';
import type { NoticeCategoryJson } from '@/types/domain/notice/entities/noticeCategoryEntity';

import { Entity } from '@/domain/entity';
import { DeleteType } from '@/domain/entityRepositoryBase';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * 掲示板カテゴリプロパティ
 */
export type NoticeCategoryProps = {
  /** カテゴリID */
  categoryId: CategoryId,
  /** カテゴリインデックス */
  categoryIndex: CategoryIndex,
  /** カテゴリ */
  category: Category,
  /** カテゴリアイテム数 */
  categoryItemCount: CategoryItemCount,
}

export class NoticeCategoryEntity extends Entity<
  NoticeCategoryProps,
  NoticeCategoryJson
> {
  /**
   * 削除タイプ
   */
  get deleteType(): DeleteType {
    return DeleteType.NoticeCategoryId;
  }

  /**
   * 削除キー
   */
  get deleteKey(): string {
    return this.categoryId.value;
  }

  /**
   * データJsonを返す
   * @returns データ
   */
  toJsonData(): NoticeCategoryJson {
    return {
      categoryId: this.categoryId.value,
      categoryIndex: this.categoryIndex.value,
      category: this.category.value,
      categoryItemCount: this.categoryItemCount.value,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityName {
    return EntityName.WagakoAppNoticeNoticeCategoryEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return `${this.categoryId.value}`;
  }

  /**
   * サブキー
   */
  get subKey() {
    return `${this.categoryId.value}#${this.category.value}`;
  }

  /**
   * カテゴリID
   */
  get categoryId(): CategoryId {
    return this._value.categoryId;
  }

  /**
   * カテゴリID
   */
  set categoryId(categoryId: CategoryId) {
    this._value.categoryId = categoryId;
  }

  /**
   * カテゴリインデックス
   */
  get categoryIndex(): CategoryIndex {
    return this._value.categoryIndex;
  }

  /**
   * カテゴリインデックス
   */
  set categoryIndex(categoryIndex: CategoryIndex) {
    this._value.categoryIndex = categoryIndex;
  }

  /**
   * カテゴリ
   */
  get category(): Category {
    return this._value.category;
  }

  /**
   * カテゴリ
   */
  set category(category: Category) {
    this._value.category = category;
  }

  /**
   * カテゴリアイテム数
   */
  get categoryItemCount(): CategoryItemCount {
    return this._value.categoryItemCount;
  }

  /**
   * カテゴリアイテム数
   */
  set categoryItemCount(categoryItemCount: CategoryItemCount) {
    this._value.categoryItemCount = categoryItemCount;
  }
}
